/* eslint-disable linebreak-style */
// ----------------------------------------------------------------------------
// Component: Shop Categories
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Autoplay, Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';

// Style includes
import 'snippets/card/card';
import 'snippets/icon/icon';
import './_shop-categories.scss';

// Swiper styles
import 'snippets/swiper-control/swiper-control';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--shop-categories';
const CAROUSEL_CLASS = 'carousel--shop-categories';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
const CARD_SELECTOR = '.card--shop-categories';
const BACKGROUND_IMAGE_SELECTOR = '.card__background-image';
const ACTIVE_CLASS = 'js-isActive';
const HTML5_VIDEO    = '.video-block--html5';
const SLIDE_LINK_SELECTOR = '.slide__link';
const play        = new Event('play.video-block');
const pause       = new Event('pause.video-block');


class iamShopCategories extends HTMLElement {
    
    constructor() {
        super();

        this.sectionIndex = this.dataset.sectionIndex;

        this.carousel = this.querySelector(CAROUSEL_SELECTOR);
        this.carousel.classList.add(`${CAROUSEL_CLASS}-${this.sectionIndex}`);

        // Generate unique btn classes for slider arrows
        this.prevButton = this.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR);
        this.nextButton = this.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR);
        this.prevButton.classList.add(`${CAROUSEL_CLASS}-btn-prev-${this.sectionIndex}`);
        this.nextButton.classList.add(`${CAROUSEL_CLASS}-btn-next-${this.sectionIndex}`);

        // Generate unique btn classes for swiper pagination
        this.pagination = this.querySelector(CAROUSEL_PAGINATION_SELECTOR);
        this.pagination.classList.add(`${CAROUSEL_CLASS}-pagination-${this.sectionIndex}`);

        this.swiper = new Swiper(this.carousel, {
            // Optional parameters
            modules: [Autoplay, Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.3,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,

            breakpoints: {
                // when window width is >= 680px
                1024: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                },
                1366: {
                    slidesPerView: 6,
                    slidesPerGroup: 6
                }
            },

            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton
            },

            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true,
                dynamicBullets: true
            },
        });

        // Function to add class if slides are less than slidesPerView
        const updateCarouselClass = () => {
            const breakpoints = this.swiper.params.breakpoints;
            const windowWidth = window.innerWidth;

            let slidesPerView = this.swiper.params.slidesPerView; // Default slidesPerView
            if (windowWidth >= 1366 && breakpoints[1366]) {
                slidesPerView = breakpoints[1366].slidesPerView;
            } else if (windowWidth >= 1024 && breakpoints[1024]) {
                slidesPerView = breakpoints[1024].slidesPerView;
            }

            if (this.swiper.slides.length < slidesPerView) {
                this.carousel.parentElement.classList.add('centered-slides');
            } else {
                this.carousel.parentElement.classList.remove('centered-slides');
            }
        };

        // Initial check
        updateCarouselClass();

        // Add event listeners
        window.addEventListener('resize', updateCarouselClass);

        // Background Image
        this.backgroundImage = this.querySelector(BACKGROUND_IMAGE_SELECTOR);

        // Get all the cards
        this.cards = this.querySelectorAll(CARD_SELECTOR);
        this.slideLinks = this.querySelectorAll(SLIDE_LINK_SELECTOR);

        this.cards.forEach(card => {

            card.addEventListener('mouseover', () => {
                
                if (!card.classList.contains(ACTIVE_CLASS)) {
                    const self = this;
                    const videoBlock = card.querySelector(HTML5_VIDEO);
                    const cardBackgroundImage = card?.dataset.cardBackgroundImage;
                    card.classList.add(ACTIVE_CLASS);
                    self.backgroundImage.src = cardBackgroundImage;

                    if (typeof(videoBlock) != 'undefined' && videoBlock != null) {
                        videoBlock.dispatchEvent(play);
                    }
    
                    setTimeout(function(){
                        self.querySelectorAll(`${CARD_SELECTOR}.${ACTIVE_CLASS}:not(:hover)`).forEach(activeCard => {
                            activeCard.classList.remove(ACTIVE_CLASS);
                            const videoBlock = activeCard.querySelector(HTML5_VIDEO);

                            if (typeof(videoBlock) != 'undefined' && videoBlock != null) {
                                videoBlock.dispatchEvent(pause);
                            }
                        });
                    }, 200);
                }
            });
        });

        this.slideLinks.forEach((link, index) => {

            link?.addEventListener('focus', () => {
                const card = link.closest(CARD_SELECTOR);
                card.classList.add('js-isFocused');

                if (!card.classList.contains(ACTIVE_CLASS)) {
                    const self = this;
                    const videoBlock = card.querySelector(HTML5_VIDEO);
                    const cardBackgroundImage = card?.dataset.cardBackgroundImage;
                    card.classList.add(ACTIVE_CLASS);
                    self.backgroundImage.src = cardBackgroundImage;
                    self.swiper.slideTo(index);

                    
                    if (typeof(videoBlock) != 'undefined' && videoBlock != null) {
                        videoBlock.dispatchEvent(play);
                    }

                    setTimeout(function(){
                        self.querySelectorAll(`${CARD_SELECTOR}.${ACTIVE_CLASS} .slide__link:not(:focus)`).forEach(link => {
                            const activeCard = link.closest(CARD_SELECTOR);
                            activeCard.classList.remove(ACTIVE_CLASS);
                            const videoBlock = activeCard.querySelector(HTML5_VIDEO);
                            
                            if (typeof(videoBlock) != 'undefined' && videoBlock != null) {
                                videoBlock.dispatchEvent(pause);
                            }
                        });
                    }, 200);
                }
            })
        });
    }
}

customElements.define('iam-shop-categories', iamShopCategories);
